var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManualenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.00049C3.895 3.00049 3 3.89549 3 5.00049V19.0005C3 20.1055 3.895 21.0005 5 21.0005H16.1719L13.293 18.1216C13.105 17.9346 13 17.6795 13 17.4145V14.0005C13 13.4485 13.448 13.0005 14 13.0005H17.4141C17.6791 13.0005 17.9341 13.1055 18.1211 13.2935L21 16.1724V5.00049C21 3.89549 20.105 3.00049 19 3.00049H5ZM7 6.00049H17C17.552 6.00049 18 6.44849 18 7.00049C18 7.55249 17.552 8.00049 17 8.00049H7C6.448 8.00049 6 7.55249 6 7.00049C6 6.44849 6.448 6.00049 7 6.00049ZM7 10.0005H10C10.552 10.0005 11 10.4485 11 11.0005C11 11.5525 10.552 12.0005 10 12.0005H7C6.448 12.0005 6 11.5525 6 11.0005C6 10.4485 6.448 10.0005 7 10.0005ZM15 15.0005V17.0005L20.1465 22.147L22.1465 20.147L17 15.0005H15ZM22.8535 20.854L20.8535 22.854L21.5859 23.5864C22.1379 24.1384 23.0339 24.1384 23.5859 23.5864C24.1379 23.0344 24.1379 22.1384 23.5859 21.5864L22.8535 20.854Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualenter);
export default __webpack_public_path__ + "static/media/Manual enter.f75ec154275579824cca0d0aa360edcf.svg";
export { ForwardRef as ReactComponent };